<template>
  <section>
    <div class="societe">
      <h1>
        <router-link class="punch" :to="{ path: '/nouvelleCommande' }"
          >start.</router-link
        >
      </h1>
      <pre>
      nom: {{ soc.nom }}
      slogan: {{ soc.slogan }}
      description: {{ soc.description }}
      siret: {{ soc.siret }}
      tel: {{ soc.tel }}
      handle: {{ soc.handle }}
    </pre
      >
    </div>
    <Stats></Stats>
  </section>
</template>
<script>
import { Societe } from "@/models/model.js";
import Stats from "@/components/stats/Stats.vue";

export default {
  components: { Stats },
  computed: {
    soc() {
      return Societe;
    }
  }
};
</script>
<style>
.societe {
}

.punch {
  display: block;
  margin: 0.5em;
  padding: 0.5em;
  border-radius: 4px;
  background-color: orange;
  color: black;
  text-align: center;
  border: thin solid #f27d27;
}

.punch:hover {
  background-color: #ff7800;
  border: thin solid brown; /* #f9de01; */
}

.punch:visited {
  color: black;
}
</style>
